import Repository from './Repository';

import store from "../store";
let currentUser = '';
let userType = '';
let resource = '';

function getApi() {
  currentUser = store.getters.currentUser;
  userType = "admin";
  resource = "/auth/v1/admin/paymentFormKey";
  if (
    currentUser.role == "MERCHANT_ADMIN" ||
    currentUser.role == "MERCHANT_USER"
  ) {
    userType = "merchchant";
    resource = "/auth/v1/merchants/paymentFormKey";
  }
}

export default {
  getAllPaymentFormKeys(paymentModeId) {  
    getApi();  
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/${paymentModeId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }
}
